import { Loading } from 'components';
import React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBarProgress from 'react-topbar-progress-indicator';
import { AuthRouteKeys, ErrorRouteKeys, MainRouteKeys } from 'routes/enums';
import { MainRoutesConfig } from 'routes/main/config';
import { checkValidRole, hasAuthenticatedSession } from 'utils/helpers';
import { useMatchedRoute } from 'utils/hooks';

const RouterSuspense = ({ children }: { children: React.ReactNode }) => {
  const [hasSession, setHasSession] = useState<boolean | null>(null);
  const navigate = useNavigate();

  const route = useMatchedRoute(Object.values(MainRouteKeys));
  const currentRoute = MainRoutesConfig[route as MainRouteKeys];

  const redirectUrl = currentRoute?.redirectUrl;

  useEffect(() => {
    let isActive = true;

    hasAuthenticatedSession().then((session) => {
      if (isActive) setHasSession(session);
    });

    return () => {
      isActive = false;
    };
  }, []);

  useEffect(() => {
    if (redirectUrl && hasSession) {
      navigate(redirectUrl, { replace: true });
    }
  }, [redirectUrl, hasSession, navigate]);

  useEffect(() => {
    if (hasSession === false) {
      navigate(AuthRouteKeys.Login, { replace: true });
    }
  }, [hasSession, navigate]);

  useEffect(() => {
    if (hasSession === true) {
      const isValid = checkValidRole(currentRoute?.roles);
      if (!isValid) {
        navigate(ErrorRouteKeys.NotFound, {
          replace: true,
        });
      }
    }
  }, [hasSession, currentRoute, navigate]);

  if (hasSession !== true) {
    return <Loading backdrop />;
  }

  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export default RouterSuspense;
